import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Assignment         from 'app/components/company-admin/grant-system/assignment';
import CadminLayout       from 'app/components/company-admin/layout/';
import AppProfile         from 'app/components/grant-system/app-profile';
import PageLoading        from 'app/components/layout/page-loading';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';

class CadminPageGrantAssignment extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  get stage() {
    const {workflow, ass} = this.props;
    if (!workflow || !ass) return null;
    return workflow.stages.find((stage) => {
      return stage.tasks.find((task) => {
        return task.id === ass.grantTaskId;
      });
    });
  }
  get task() {
    const {ass} = this.props;
    if (!ass) return null;
    return (this.stage?.tasks || []).find(t => t.id === ass.grantTaskId) || null;
  }

  get title() {
    let str = 'Task: ';
    const {app} = this.props;
    return (this.task && app)
      ? `${this.task.title} #${app.number}`
      : 'Task';
  }

  renderApp() {
    const {program, app, ass} = this.props;
    if (!program || !app) return null;
    return <AppProfile program={program} app={app} assId={ass?.id} className="capg-ass-app-pro" center={false} />;
  }

  renderAssBox() {
    const {task, stage} = this;
    const {company, ass, app} = this.props;
    if (!task || !company || !stage || !ass || !app) return null;
    return (
      <Assignment task={task} app={app} stage={stage} company={company} ass={ass} />
    );
  }

  render() {
    const {company, ass, program, workflow, app} = this.props;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout company={company} activeItem="grant-my-tasks" className="capg-ass" floatNav>
        <Meta title={`${this.title} | Millie`} />
        <div className="ca-main-head">
          <Link className="ca-main-head-back" href={paths.cadminGrantMyTasks(company.slug)}><Icon.Caret direction="left" /> My Tasks</Link>
          <h1 className="ca-main-head-h1">{this.title}</h1>
          <div className="ca-main-head-actions">
          </div>
        </div>
        {/* <br /><br /><br /> */}
        {/* {this.renderAssBox()} */}
        {/* <br /><br /><br /> */}
        {/* {this.renderApp()} */}

        <div className="ca-gapp-page-cols">
          <div className="ca-gapp-page-cols-main">
            {this.renderApp()}
          </div>
          <div className="ca-gapp-page-cols-side">
            {this.renderAssBox()}
          </div>
        </div>
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  ass: GrantSysDuck.Slx.pathAss(state),
  program: GrantSysDuck.Slx.pathAssProgram(state),
  workflow: GrantSysDuck.Slx.pathAssWorkflow(state),
  app: GrantSysDuck.Slx.pathAssApp(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantAssignment);
